// extracted by css-extract-rspack-plugin
export default {"Root":"RightViewFooterButtonGroup-module__Root___Syg4v"};